import React from "react";
import Select, { components, useStateManager } from "react-select";
import { customStyles } from "../../../../pages/customStyles";

const FacultyProfileStep2 = ({
  list,
  styles,
  listErrors,
  handleChange,
  handleSelectCH,
  city,
  txtAdPhno,
  txtAdPsname,
  txtAdParea,
  txtAdPland,
  txtAdPpost,
  txtAdPtaluk,
  txtAdPpincode,
  txtAdPcity,
  txtAdPdistrict,
  txtAdPerhno,
  txtAdPersname,
  txtAdPerarea,
  txtAdPerland,
  txtAdPererpost,
  txtAdPertaluk,
  txtAdPerpincode,
  txtAdPercity,
  txtAdPerdistrict,
  txtAdPerstate,
}) => {
  return (
    <div className="CommunicationForm">
      {/* present address */}
      <fieldset className="mt-3">
        <legend className="w-auto">Present Address</legend>
        <form className="row g-3">
          <div className="col-md-6">
            <label for="address1" class="form-label confirm_value ">
              House/Flat Number & Name
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              ref={txtAdPhno}
              id="BuildingNumberPresent"
              type="text"
              name="BuildingNumberPresent"
              onChange={handleChange}
              value={list.BuildingNumberPresent}
              placeholder=" House/Building Number"
              autoComplete="BuildingNumberPresent"
              required
            />
            {listErrors.BuildingNumberPresent && (
              <small className="error_message">
                {listErrors.BuildingNumberPresent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="address2" class="form-label confirm_value ">
              Street Name
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              ref={txtAdPsname}
              id="StreetNamePresent"
              type="text"
              name="StreetNamePresent"
              onChange={handleChange}
              value={list.StreetNamePresent}
              placeholder="Street Name"
              autoComplete="StreetNamePresent"
              required
            />
            {listErrors.StreetNamePresent && (
              <small className="error_message">
                {listErrors.StreetNamePresent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="address3" class="form-label confirm_value ">
              Locality/Area
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm `}
              ref={txtAdParea}
              id="AreaPresent"
              type="text"
              name="AreaPresent"
              onChange={handleChange}
              value={list.AreaPresent}
              placeholder="Locality/Area"
              autoComplete="AreaPresent"
              required
            />

            {listErrors.AreaPresent && (
              <small className="error_message">{listErrors.AreaPresent}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="landmark" class="form-label confirm_value ">
              Landmark
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              ref={txtAdPland}
              id="LandmarkPresent"
              type="text"
              name="LandmarkPresent"
              onChange={handleChange}
              value={list.LandmarkPresent}
              placeholder=" Landmark"
              autoComplete="LandmarkPresent"
              required
            />
            {listErrors.LandmarkPresent && (
              <small className="error_message">
                {listErrors.LandmarkPresent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="post_name" class="form-label confirm_value ">
              Post
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              ref={txtAdPpost}
              id="PostPresent"
              type="text"
              name="PostPresent"
              onChange={handleChange}
              value={list.PostPresent}
              placeholder=" Post"
              autoComplete="PostPresent"
              required
            />
            {listErrors.PostPresent && (
              <small className="error_message">{listErrors.PostPresent}</small>
            )}
          </div>
          <div className="col-md-6">
            <label for="taluk" class="form-label confirm_value ">
              Taluk
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              ref={txtAdPtaluk}
              id="TalukPresent"
              type="text"
              name="TalukPresent"
              onChange={handleChange}
              value={list.TalukPresent}
              placeholder=" Taluk"
              autoComplete="TalukPresent"
              required
            />
            {listErrors.TalukPresent && (
              <small className="error_message">{listErrors.TalukPresent}</small>
            )}
          </div>
          {/* Postal Code Input */}
          <div className="col-md-6">
            <label htmlFor="postal_code" className="form-label confirm_value">
              Pin/Postal Code
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              ref={txtAdPpincode}
              id="PincodePresent"
              type="text"
              onChange={handleChange}
              value={list.PincodePresent}
              name="PincodePresent"
              placeholder="Pin/Postal Code"
              autoComplete="PincodePresent"
              required
            />
            {listErrors.PincodePresent && (
              <small className="error_message">
                {listErrors.PincodePresent}
              </small>
            )}
          </div>

          {/* City Field: Switches between Input & Dropdown */}
          <div className="col-md-6">
            <label htmlFor="city" className="form-label confirm_value">
              City/Town/Village
            </label>

            <Select
              className={`shadow-none input-font-size margin-left-zero`}
              placeholder="Select City"
              ref={txtAdPcity}
              id="FacultyCityPresent"
              name="CityPresent"
              // disabled={list.admission_status === 1 ? true : false}
              value={
                list.CityPresent !== null && list.CityPresent !== ""
                  ? {
                      value: list.CityPresent,
                      label: list.CityPresent,
                    }
                  : null
              }
              onChange={(option) => handleSelectCH(option, "CityPresent")}
              options={
                city
                  .filter((item) => item && item.label) // Filter out null and undefined elements
                  .sort((a, b) => a.label.localeCompare(b.label)) // Sort options alphabetically by label
              }
              isSearchable={true}
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option.label.toLowerCase().includes(searchText.toLowerCase())
              }
              styles={customStyles}
            />
            {listErrors.CityPresent && (
              <small className="error_message">{listErrors.CityPresent}</small>
            )}
          </div>

          {/* District Field (Auto-filled) */}
          <div className="col-md-6">
            <label htmlFor="district_name" className="form-label confirm_value">
              District
            </label>
            <input
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              ref={txtAdPdistrict}
              id="districtPresent"
              type="text"
              value={list.districtPresent}
              name="districtPresent"
              placeholder="district"
              disabled
              required
            />
            {listErrors.districtPresent && (
              <small className="error_message">
                {listErrors.districtPresent}
              </small>
            )}
          </div>

          {/* State Field (Auto-filled) */}
          <div className="col-md-6">
            <label htmlFor="state_name" className="form-label confirm_value">
              State/Union Territory
            </label>
            <input
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              id="statePresent"
              type="text"
              value={list.statePresent}
              name="statePresent"
              placeholder=" State/Union Territory"
              disabled
              required
            />
            {listErrors.statePresent && (
              <small className="error_message">{listErrors.statePresent}</small>
            )}
          </div>
        </form>
      </fieldset>

      {/* permanent address */}
      <fieldset className="mt-3">
        <legend className="w-auto">Permanent Address</legend>
        <form className="row g-3">
          <div className="mb-3">
            <input
              className={`${styles.checkBox_input} me-2`}
              type="checkbox"
              id="SamePresentAddress"
              name="SamePresentAddress"
              onChange={handleChange}
              value={list.SamePresentAddress}
              checked={list.SamePresentAddress === true ? true : false}
            ></input>
            <label
              htmlFor="present_address"
              for="present_address"
              class="form-label confirm_label "
            >
              Same as Present Address
            </label>
          </div>
        </form>
        <form className="row g-3">
          <div className="col-md-6">
            <label for="address1" class="form-label confirm_value ">
              House/Flat Number & Name
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPerhno}
              id="BuildingNumberPermanent"
              type="text"
              name="BuildingNumberPermanent"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.BuildingNumberPermanent
                  : list.BuildingNumberPresent
              }
              placeholder=" House/Building Number"
              autoComplete="BuildingNumberPermanent"
              required
            />
            {listErrors.BuildingNumberPermanent && (
              <small className="error_message">
                {listErrors.BuildingNumberPermanent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="address2" class="form-label confirm_value ">
              Street Name
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPersname}
              id="StreetNamePermanent"
              type="text"
              name="StreetNamePermanent"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.StreetNamePermanent
                  : list.StreetNamePresent
              }
              placeholder="Street Name"
              autoComplete="StreetNamePermanent"
              required
            />
            {listErrors.StreetNamePermanent && (
              <small className="error_message">
                {listErrors.StreetNamePermanent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="address3" class="form-label confirm_value ">
              Locality/Area
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPerarea}
              id="AreaPermanent"
              type="text"
              name="AreaPermanent"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.AreaPermanent
                  : list.AreaPresent
              }
              placeholder="Locality/Area"
              autoComplete="AreaPermanent"
              required
            />
            {listErrors.AreaPermanent && (
              <small className="error_message">
                {listErrors.AreaPermanent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="landmark" class="form-label confirm_value ">
              Landmark
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPerland}
              id="LandmarkPermanent"
              type="text"
              name="LandmarkPermanent"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.LandmarkPermanent
                  : list.LandmarkPresent
              }
              placeholder="Landmark"
              autoComplete="LandmarkPermanent"
              required
            />
            {listErrors.LandmarkPermanent && (
              <small className="error_message">
                {listErrors.LandmarkPermanent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="post_name" class="form-label confirm_value ">
              Post
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPererpost}
              id="PostPermanent"
              type="text"
              name="PostPermanent"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.PostPermanent
                  : list.PostPresent
              }
              placeholder=" Post"
              autoComplete="PostPermanent"
              required
            />
            {listErrors.PostPermanent && (
              <small className="error_message">
                {listErrors.PostPermanent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="taluk" class="form-label confirm_value ">
              Taluk
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPertaluk}
              id="TalukPermanent"
              type="text"
              name="TalukPermanent"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.TalukPermanent
                  : list.TalukPresent
              }
              placeholder=" Taluk"
              autoComplete="TalukPermanent"
              required
            />
            {listErrors.TalukPermanent && (
              <small className="error_message">
                {listErrors.TalukPermanent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="postal_code" class="form-label confirm_value ">
              Pin/Postal Code
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPerpincode}
              id="PincodePermanent"
              type="text"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.PincodePermanent
                  : list.PincodePresent
              }
              name="PincodePermanent"
              placeholder="Pin/Postal Code"
              autoComplete="PincodePermanent"
              required
            />
            {listErrors.PincodePermanent && (
              <small className="error_message">
                {listErrors.PincodePermanent}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="city" className="form-label confirm_value">
              City/Town/Village
            </label>
            {list.SamePresentAddress !== true ? (
              <Select
                className={`shadow-none input-font-size margin-left-zero`}
                ref={txtAdPercity}
                id="FacultyCityPermanent"
                disabled={list.SamePresentAddress === true}
                name="CityPermanent"
                value={
                  list.CityPermanent !== null && list.CityPermanent !== ""
                    ? {
                        value: list.CityPermanent,
                        label: list.CityPermanent,
                      }
                    : null
                }
                onChange={(option) => handleSelectCH(option, "CityPermanent")}
                options={city
                  .filter((item) => item && item.label)
                  .sort((a, b) => a.label.localeCompare(b.label))}
                isSearchable={true}
                placeholder="Select an option"
                maxMenuHeight={200}
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                }
                styles={customStyles}
              />
            ) : (
              <input
                ref={txtAdPercity}
                id="FacultyCityPermanent"
                type="text"
                onChange={handleChange}
                disabled={list.SamePresentAddress === true}
                value={
                  list.SamePresentAddress === true
                    ? list.CityPresent
                    : list.CityPermanent
                }
                name="CityPermanent"
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                placeholder="City"
                autoComplete="CityPermanent"
                required
              />
            )}
            {listErrors.CityPermanent && (
              <small className="error_message">
                {listErrors.CityPermanent}
              </small>
            )}
          </div>
          <div className="col-md-6">
            <label for="district_name" class="form-label confirm_value ">
              District
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPerdistrict}
              id="districtPermanent"
              type="text"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.districtPermanent
                  : list.districtPresent
              }
              name="districtPermanent"
              placeholder="district"
              autoComplete="districtPermanent"
              required
            />
            {listErrors.districtPermanent && (
              <small className="error_message">
                {listErrors.districtPermanent}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label for="state_name" class="form-label confirm_value ">
              State/Union Territory
            </label>
            <input
              className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                list.SamePresentAddress === true ? "bg-light text-muted" : ""
              }`}
              style={{
                cursor:
                  list.SamePresentAddress === true ? "not-allowed" : "auto",
              }}
              ref={txtAdPerstate}
              id="statePermanent"
              type="text"
              onChange={handleChange}
              value={
                list.SamePresentAddress !== true
                  ? list.statePermanent
                  : list.statePresent
              }
              name="statePermanent"
              placeholder="State/Union Territory"
              autoComplete="statePermanent"
              required
            />
            {listErrors.statePermanent && (
              <small className="error_message">
                {listErrors.statePermanent}
              </small>
            )}
          </div>
        </form>
      </fieldset>
    </div>
  );
};

export default FacultyProfileStep2;
